import { render, staticRenderFns } from "./ViewPersonalLiabilityPolicyApplication.vue?vue&type=template&id=1c8d4545"
import script from "./ViewPersonalLiabilityPolicyApplication.vue?vue&type=script&lang=ts"
export * from "./ViewPersonalLiabilityPolicyApplication.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports